export class ModalManager {

}

export const modalManager = new ModalManager();
